import React from "react";
import { Crosshair, CheckCircle2, Award, Sparkles, ShieldCheck, PhoneCall } from "lucide-react";
import { WHY_REASONS } from "../mock";

const ICON_MAP = {
  "fa-bullseye": Crosshair,
  "fa-check-double": CheckCircle2,
  "fa-award": Award,
  "fa-om": Sparkles,
  "fa-user-shield": ShieldCheck,
  "fa-phone-volume": PhoneCall,
};

const WhyChoose = () => {
  return (
    <section id="why" className="why-section">
      <div className="container">
        <div className="why-head">
          <span className="section-label center">Why Guruji?</span>
          <h2 className="section-title">Reasons to Choose<br/><em>Pandit C. S. Joshi</em></h2>
        </div>
        <div className="why-grid">
          {WHY_REASONS.map((r, i) => {
            const Icon = ICON_MAP[r.icon] || Sparkles;
            return (
              <div className="why-card" key={i}>
                <div className="why-icon"><Icon size={22} /></div>
                <h3>{r.title}</h3>
                <p>{r.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
